module.exports = __webpack_public_path__ + "img/chevron-down.7f911653.svg";